import React, { useEffect, useState } from "react";
import { FACEBOOK_APP_ID } from "@wantable/Config";
import { loginToWantableWithSocialmediaToken } from "../helpers/loginWithSocialMedia";

interface IFacebookResponse {
  status: "connected" | "not_authorized" | "unknown";
  authResponse?: {
    accessToken: string;
    expiresIn: string;
    reauthorize_required_in: string;
    signedRequest: string;
    userID: string;
  };
}

const useFacebookAuthentication = () => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    // @ts-ignore
    window.fbAsyncInit = () => {
      // @ts-ignore
      FB.init({
        appId: FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v15.0",
      });
    };
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    script.onload = () => {
      setIsScriptLoaded(true);
    };
  }, []);

  const loginWithFacebook = () => {
    if (!isScriptLoaded) {
      return;
    }

    // @ts-ignore
    FB.getLoginStatus((response: IFacebookResponse) => {
      if (response.status === "connected" && response.authResponse) {
        loginToWantableWithSocialmediaToken(
          response.authResponse.accessToken,
          "facebook"
        );
      } else {
        // @ts-ignore
        FB.login((response: IFacebookResponse) => {
          if (response.status === "connected" && response.authResponse) {
            loginToWantableWithSocialmediaToken(
              response.authResponse.accessToken,
              "facebook"
            );
          }
        });
      }
    });
  };

  return { loginWithFacebook };
};

export default useFacebookAuthentication;
